var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.5H27.5",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.5H27.5",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.5H27.5",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.5H12.5C8.634 22.5 5.5 19.366 5.5 15.5C5.5 11.634 8.634 8.5 12.5 8.5H15.5",
    stroke: "#212121",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.5L15.5 22.5L11.5 26.5",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/Reorder.777bec52.svg";
export { ForwardRef as ReactComponent };